export const cookieConfig = {
  maxAge: 60 * 60 * 24 * 365,
  path: "/"
};

export const STORAGE_KEY_TOKEN = "token";
// can be removed in a year after the next release, regarding this comment date.
export const _deprecated_STORAGE_KEY_REFRESH_TOKEN = "refresh_token";
export const STORAGE_KEY_REFRESH_COUNT = "refreshCount";
export const STORAGE_KEY_CONTENT_CACHE_LAST_CHECK = "content_cache_last_check";
export const STORAGE_KEY_CONTENT_VERSION = "content_version";

export const CUSTOM_EVENT_APP_VERSION_DIFFERS = "appVersionDiffers";
export const CUSTOM_EVENT_CONTENT_VERSION_DIFFERS = "contentVersionDiffers";
export const CUSTOM_EVENT_CONTENT_LOGOUT = "logout";

export const CUSTOM_EVENT_STORAGE_QUOTA_EXCEEDED = "storageQuotaExceeded";
